<template
  ><v-card elevation="0">
    <v-card-title class="font-weight-regular">
      <v-spacer />
      <v-btn dark color="indigo" @click="create">
        <v-icon left>mdi-plus</v-icon>
        {{ $t('ITEM.NEW') }} {{ $t('CONTRACTS.ITEM') }}
      </v-btn>
    </v-card-title>

    <v-card-text>
      <contracts-list
        v-bind="contractsListData"
        :options.sync="options"
        @show="show"
      />
    </v-card-text>
    <v-dialog
      v-if="dialog"
      v-model="dialog"
      persistent
      width="unset"
      max-width="800"
    >
      <component
        :is="component.name"
        v-bind="component.data"
        :building-complex-id="value.id"
        :errors="errors.getAll()"
        @create="createContract"
        @update="updateContract"
        @remove="removeContract"
        @cancel="cancelDialog"
        @update-prop="clearErrorByName($event)"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import DataOptions from '@/modules/_global/classes/DataOptions';
import { ContractsService } from '@/services/contracts.service';
import errors from '@/modules/_global/mixins/errors';
import ContractsList from '@/modules/building_complexes_contracts/components/ContractsList';
import { debounce } from 'lodash';

const DEBOUNCE_DELAY = 300;

export default {
  name: 'Contracts',

  components: {
    ContractsList,
    CreateContract: () =>
      import(
        '@/modules/building_complexes_contracts/components/CreateContract'
      ),
    ShowContract: () =>
      import('@/modules/building_complexes_contracts/components/ShowContract')
  },

  mixins: [errors],

  props: {
    value: {
      type: Object,
      default: () => ({})
    }
  },

  data() {
    return {
      options: {
        page: 1,
        itemsPerPage: 10,
        sortBy: ['date_entered'],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        mustSort: false,
        multiSort: false
      },
      contractsListData: {
        contracts: [],
        meta: {}
      },
      dialog: false,
      component: null
    };
  },

  computed: {
    preparedOptions() {
      return DataOptions.createFromObject(this.options).toBackendFormat();
    }
  },

  watch: {
    options: {
      deep: true,
      immediate: true,
      handler() {
        this.refreshData();
      }
    },
    'value.id': {
      deep: true,
      immediate: true,
      handler: 'refreshData'
    }
  },

  methods: {
    getDataContracts: debounce(function getContracts() {
      if (!this.value.id) {
        return;
      }
      ContractsService.getList({
        ...this.preparedOptions,
        building_complex: [this.value.id]
      }).then(({ data }) => {
        this.contractsListData.contracts = data.data;
        this.contractsListData.meta = data.meta;
      });
    }, DEBOUNCE_DELAY),

    create() {
      this.dialog = true;
      this.component = {
        name: 'CreateContract',
        data: {
          value: {
            street: this.value.management_company.street,
            zip: this.value.management_company.zip,
            city: this.value.management_company.city,
            per_address: this.value.management_company.name
          }
        }
      };
    },

    show(v) {
      ContractsService.getById(v.id)
        .then(({ data }) => {
          this.dialog = true;
          this.component = {
            name: 'ShowContract',
            data: {
              value: { ...data },
              details: {
                business_customer: this.value.business_customer,
                management_company: this.value.management_company,
                building_complex_name: this.value.name,
                service: data.service
              }
            }
          };
        })
        .catch(console.error);
    },

    cancelDialog() {
      this.dialog = false;
      this.component = null;
    },

    cancelDialogAndRefresh() {
      this.refreshData();
      this.cancelDialog();
    },

    refreshData() {
      this.getDataContracts();
    },

    createContract(form) {
      ContractsService.create(this.value.id, form)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
        })
        .catch(this.handleErrors);
    },

    updateContract(form) {
      ContractsService.update(form.id, form)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
        })
        .catch(this.handleErrors);
    },

    removeContract() {
      ContractsService.remove(this.component.data.id)
        .then(({ data }) => {
          this.cancelDialogAndRefresh();
          this.$store.commit('snackbar/setSnack', {
            status: 'success',
            text: this.$t('MESSAGE.SUCCESS')
          });
        })
        .catch(this.handleErrors);
    }
  }
};
</script>
